import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InspectionForm } from 'src/app/models/inspections/inspection-form';
import { Question } from 'src/app/models/inspections/question';
import { ResponseType } from 'src/app/models/inspections/response-type';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import {
  fileInputParams,
  HttpService,
  IButtonlabelEdit,
  MessageService,
  ScreenSizeUtil,
} from 'brainloper-ui';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { RouterEvent } from '@angular/router';

@Component({
    selector: 'app-generic-question',
    templateUrl: './generic-question.component.html',
    styleUrls: ['./generic-question.component.scss'],
    standalone: false
})
export class GenericQuestionComponent implements OnInit, OnChanges {
  @Input() showFilters: boolean = true;
  @Input() addQuestion: boolean = true;
  @Input() cdkDragEnabled: boolean = false;
  @Input() showTitle: boolean = true;
  @Input() questionsBank: boolean = true;
  @Input() bodyQuestions: Array<Question> = null;

  @Output() questionAdded = new EventEmitter<Question>();
  @Output() questionDeleted = new EventEmitter<Question>();
  @Output() questionEdited = new EventEmitter<Question>();
  @Output() formAccordingToVersion = new EventEmitter<Question>();

  public isMobile = ScreenSizeUtil.isMobile();
  public questionId: number = 0;
  public positionChange: boolean = false;
  public filteredQuestions: Array<Question> = [];
  public searchTerm: string = '';
  public responseType: Array<ResponseType>;
  public selectedResponseType: number = 0;
  public labels: Array<IButtonlabelEdit> = [];
  public inspectionForm = new InspectionForm();
  public fileInput: fileInputParams = {
    typeFile: 'imagen',
    input: 'vista',
    label: 'foto',
    edit: true,
    style: {
      width: '100%',
      height: screen.width > 400 ? '300px' : '150px',
      border: '1px solid black',
    },
  };

  constructor(
    public dialog: MatDialog,
    private http: HttpService,
    private message: MessageService
  ) {
    this.isMobile = ScreenSizeUtil.isMobile();
  }

  ngOnInit(): void {
    this.init();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['bodyQuestions']) {
      this.bodyQuestions = changes['bodyQuestions'].currentValue || [];
      this.filterQuestions();
    }
  }

  async init() {
    this.message.openLoading('Cargando', 'Cargando preguntas');
    this.searchTerm = '';
    //this.selectedResponseType = null;
    if (this.questionsBank) {
      let res: Array<Question> = await this.http.getDataBody(
        `${EndpointDictionary.PreopQuestion.ALL_QUESTIONS}`
      );
      this.bodyQuestions = res;
    }
    let resType: Array<ResponseType> = await this.http.getDataBody(
      `${EndpointDictionary.PreopResponseType.PREOP_TYPE_RESPONSE_COMBO}`
    );
    this.responseType = resType;
    this.filteredQuestions = this.bodyQuestions;
    this.message.closeLoading();
  }

  filterQuestions() {
    this.filteredQuestions = this.bodyQuestions.filter((pregunta) => {
      const matchesSearch = pregunta.question
        .toLowerCase()
        .includes(this.searchTerm.toLowerCase());

      if (this.selectedResponseType === 0) {
        return matchesSearch;
      }

      return (
        matchesSearch &&
        pregunta.responseTypeId === this.selectedResponseType
      );
    })
    // this.filteredQuestions = this.bodyQuestions.filter((pregunta) => {
    //   const matchesSearch = pregunta.question
    //     .toLowerCase()
    //     .includes(this.searchTerm.toLowerCase());

    //   if (this.selectedResponseType === 0) {
    //     return matchesSearch;
    //   }

    //   // Mapear responseType a responses esperadas en bodyQuestions
    //   const mappedResponse = this.mapResponseTypeToResponses(
    //     this.selectedResponseType
    //   );

    //   // Verificar si las respuestas de la pregunta coinciden con el tipo de respuesta seleccionado
    //   const matchesResponseType =
    //     JSON.stringify(pregunta.responses.sort()) ===
    //     JSON.stringify(mappedResponse.sort());

    //   //return matchesSearch && matchesResponseType;
    // });
  }

  mapResponseTypeToResponses(responseType: string): string[] {
    if (responseType === 'Actualizar Medidor actual (horas/km/ciclos)') {
      return ['Numero'];
    }
    return responseType.split(' / ');
  }

  addNewQuestion($event: Event | RouterEvent) {
    this.questionAdded.emit();
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousIndex != event.currentIndex) {
      this.positionChange = true;
    }
    if (this.cdkDragEnabled) {
      moveItemInArray(
        this.bodyQuestions,
        event.previousIndex,
        event.currentIndex
      );

      this.bodyQuestions = [...this.bodyQuestions];
      this.filterQuestions();
    }
  }

  async editQuestion(Question: Question) {
    this.questionEdited.emit(Question);
  }

  async deleteQuestion(Question: Question) {
    this.questionDeleted.emit(Question);
  }

  async saveOrder() {
    this.message.openLoading('Cargando', 'Actualizando');
    let body = [];
    this.bodyQuestions.forEach((element, index) => {
      body.push({
        id: element.questionIdByForm,
        orderNumber: index,
      });
    });
    await this.http.putDataPromise(
      EndpointDictionary.QuestionInspectionForm.QUESTION_FORM_ORDER,
      body
    );
    setTimeout(() => {
      this.positionChange = false;
      this.message.SuccessToast('Actualizado correctamente');
      this.message.closeLoading();
    }, 1000);
  }

  getFormAccordingToVersion($event: Event | RouterEvent) {
    this.formAccordingToVersion.emit();
  }
}
